import { jsx as _jsx } from "react/jsx-runtime";
import useInView from 'react-cool-inview';
import 'intersection-observer';
import * as Styled from './item.styles';
const { itemSnapPositions } = Styled;
export const Item = ({ children, itemIndex, itemMaxWidth, itemMinWidth, itemSnapPosition, itemSpacing, itemSpacingConfined, itemSpacingWide, itemWidth, itemWidthConfined, itemWidthWide, lastItemSpace, lastItemSpaceConfined, lastItemSpaceWide, tabbable = false, onEnter, }) => {
    const { observe } = useInView({
        threshold: 0.5,
        onEnter: ({ scrollDirection }) => {
            onEnter(scrollDirection.horizontal, itemIndex);
        },
    });
    return (_jsx(Styled.Item, { "$itemMaxWidth": itemMaxWidth, "$itemMinWidth": itemMinWidth, "$itemSnapPosition": itemSnapPosition, "$itemSpacing": itemSpacing, "$itemSpacingConfined": itemSpacingConfined, "$itemSpacingWide": itemSpacingWide, "$itemWidth": itemWidth, "$itemWidthConfined": itemWidthConfined, "$itemWidthWide": itemWidthWide, "$lastItemSpace": lastItemSpace, "$lastItemSpaceConfined": lastItemSpaceConfined, "$lastItemSpaceWide": lastItemSpaceWide, ref: observe, tabIndex: tabbable ? 0 : -1, children: children }));
};
Item.displayName = 'Item';
//# sourceMappingURL=item.js.map